module.exports = __webpack_public_path__ + "img/defaultavatar.351126eb.jpg";